// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"06e9fd65","973":"fb691aca"}[chunkId] + ".chunk.js";
};